// import moment from 'moment';

/**
 * verify Feild and freeback pass or not 
 * @param {*} form form data 
 * @param {*} refVerifyFields if null, verify all field; ex: ["thingName", "SN", "laborWarranty", "partsWarranty"]
 */
export const verifyForm = (form, refVerifyFields) => {
    let pass = false;
    if (form) {
        const values = form.values;
        if (values && !form.syncErrors) {
            // check all field has values
            pass = true;
            if (refVerifyFields) {
                // only verify these field
                refVerifyFields.forEach(fieldName => {
                    if (!values[fieldName] && values[fieldName] !== 0) {
                        pass = false;
                    }
                    else if (Array.isArray(values[fieldName]) && values[fieldName].length === 0) {
                        pass = false;
                    } else if (Array.isArray(values[fieldName]) && values[fieldName].length !== 0) {
                        if (fieldName === 'ruleSet') {
                            const ruleSetArrayErrors = [];
                            values[fieldName].forEach((rule, ruleIndex) => {
                                const ruleErrors = {};
                                if (!rule || !rule.targetType) {
                                    ruleErrors.targetType = 'Required';
                                    ruleSetArrayErrors[ruleIndex] = ruleErrors;
                                    pass = false;
                                } else if (!rule || !rule.target) {
                                    ruleErrors.target = 'Required';
                                    ruleSetArrayErrors[ruleIndex] = ruleErrors;
                                    pass = false;
                                }
                            });
                        } else if (fieldName === 'ruleSetSchedules') {
                            const schedulesArrayErrors = [];
                            values[fieldName].forEach((schedule, scheduleIndex) => {
                                const scheduleErrors = {};
                                if (!schedule || !schedule.triggerTime) {
                                    scheduleErrors.triggerTime = 'Required';
                                    schedulesArrayErrors[scheduleIndex] = scheduleErrors;
                                    pass = false;
                                } else if (!schedule || !schedule.action) {
                                    scheduleErrors.action = 'Required';
                                    schedulesArrayErrors[scheduleIndex] = scheduleErrors;
                                    pass = false;
                                } else if (!schedule || !schedule.repeat) {
                                    scheduleErrors.repeat = 'Required';
                                    schedulesArrayErrors[scheduleIndex] = scheduleErrors;
                                    pass = false;
                                }
                            });
                        }
                    }
                });
            } else {
                const verifyAllFields = form.registeredFields;
                // verify all field
                for (const fieldName in verifyAllFields) {
                    if (!values[fieldName] && values[fieldName] !== 0) {
                        pass = false;
                    }
                }
            }
        }
    }
    return pass;
}

// export const verifyFormAndGetErroMsg = (form, refVerifyFields) => {
//     let resultObj = {};
//     const errors = {};
//     let pass = false;
//     if (form) {
//         const values = form.values;
//         if (values && !form.syncErrors) {
//             // check all field has values
//             pass = true;
//             if (refVerifyFields) {
//                 // only verify these field
//                 refVerifyFields.forEach(fieldName => {
//                     if (!values[fieldName] && values[fieldName] !== 0 ) {
//                         pass = false;
//                     }
//                     else if (Array.isArray(values[fieldName]) && values[fieldName].length === 0) {
//                         pass = false;
//                     } else if (Array.isArray(values[fieldName]) && values[fieldName].length !== 0) {
//                         if (fieldName === 'ruleSet') {
//                             console.log('------------------------------------ruleSet');
//                             const ruleSetArrayErrors = [];
//                             values[fieldName].forEach((rule, ruleIndex) => {
//                                 console.log('ruleIndex:' + ruleIndex + '   targetType:' + rule.targetType + '  target:' + rule.target);
//                                 const ruleErrors = {};
//                                 if (!rule || !rule.targetType) {
//                                     ruleErrors.targetType = 'Required';
//                                     ruleSetArrayErrors[ruleIndex] = ruleErrors;
//                                     pass = false;
//                                 } else if (!rule || !rule.target) {
//                                     ruleErrors.target = 'Required';
//                                     ruleSetArrayErrors[ruleIndex] = ruleErrors;
//                                     pass = false;
//                                 }
//                                 console.log('-----------ruleSetArrayErrors');
//                                 console.log(ruleSetArrayErrors);
//                             });
//                             if (ruleSetArrayErrors.length) {
//                                 errors.ruleSet = ruleSetArrayErrors;
//                                 Object.assign(resultObj, {"errors": errors});
//                             }
//                         } else if (fieldName === 'ruleSetSchedules') {
//                             console.log('------------------------------------ruleSetSchedules');
//                             const schedulesArrayErrors = [];
//                             values[fieldName].forEach((schedule, scheduleIndex) => {
//                                 console.log('scheduleIndex:' + scheduleIndex + '   triggerTime:' + schedule.triggerTime + '   action:' + schedule.action+ '   repeat:' + schedule.repeat);
//                                 const scheduleErrors = {};
//                                 if (!schedule || !schedule.triggerTime) {
//                                     scheduleErrors.triggerTime = 'Required';
//                                     schedulesArrayErrors[scheduleIndex] = scheduleErrors;
//                                     pass = false;
//                                 } else if (!schedule || !schedule.action) {
//                                     scheduleErrors.action = 'Required';
//                                     schedulesArrayErrors[scheduleIndex] = scheduleErrors;
//                                     pass = false;
//                                 } else if (!schedule || !schedule.repeat) {
//                                     scheduleErrors.repeat = 'Required';
//                                     schedulesArrayErrors[scheduleIndex] = scheduleErrors;
//                                     pass = false;
//                                 }
//                                 console.log('-----------schedulesArrayErrors');
//                                 console.log(schedulesArrayErrors);
//                             });
//                             if (schedulesArrayErrors.length) {
//                                 errors.schedule = schedulesArrayErrors;
//                                 Object.assign(resultObj, {"errors": errors});
//                             }
//                         }
//                     }
//                 });
//             } else {
//                 const verifyAllFields = form.registeredFields;
//                 // verify all field
//                 for (const fieldName in verifyAllFields) {
//                     if (!values[fieldName] && values[fieldName] !== 0) {
//                         pass = false;
//                     }
//                 }
//             }
//         }
//     }
//     Object.assign(resultObj, {"pass": pass});
//     return resultObj;
// }

const verifyEmail = (value, refMsg) => {
    const msg = refMsg ? refMsg : '* Invalid email address';
    return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? msg : undefined;
}

const verifyDigit = (value, refMsg) => {
    const msg = refMsg ? refMsg : '* Invalid digit';
    return value && !/^[+-]?[0-9]+$/.test(value) ? msg : undefined;
}

const verifyFloat = (value, refMsg) => {
    const msg = refMsg ? refMsg : '* Invalid float';
    return value && !/^[+-]?([0-9]*[.])?[0-9]+$/.test(value) ? msg : undefined;
}

const verifyCommaDigit = (value, refMsg) => {
    const msg = refMsg ? refMsg : '* Invalid float';
    return value && !/^([0-9]*[,])*[0-9]+$/.test(value) ? msg : undefined;
}

const verifyUrl = (value, refMsg) => {
    const msg = refMsg ? refMsg : '* Invalid Url';
    return value && !/(ht|f)tp(s?):\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-.?,'/\\+&amp;%$#_]*)?/.test(value) ? msg : undefined;
}


export const vaildFloat = (value, formObj, e, fieldName) => {
    return verifyFloat(value, '* Invalid float');
}

export const vaildCommaDigit = (value, formObj, e, fieldName) => {
    return verifyCommaDigit(value, '* Invalid number list (Int,Int,Int,...)');
}

export const verifyNumber = (value, formObj, e, fieldName) => {
    return verifyDigit(value, '* Invalid number');
}

const maxInteger = (max) => (value) => {
    return value && parseInt(value) > max ? `* Must be ${max} or less` : undefined
}

export const verifyAccount = (value, formObj, e, fieldName) => {
    return verifyEmail(value, 'Invalid email address.');
}

const verifyUpperCase = (value, refMsg) => {
    const msg = refMsg ? refMsg : '* Invalid upper case letter.';
    return value && !/^[A-Z0-9._%+-/ ]+$/.test(value) ? msg : undefined;
}

export const verifyUpperLetter = (value, formObj, e, fieldName) => {
    return verifyUpperCase(value, '* Must be uppercase');
}

export const maxminLength = (min, max) => (value) => {
    return value && (value.length < min || value.length > max) ? `* Must between ${min} and ${max} characters` : undefined
}

const minLength = (min) => (value) => {
    return value && value.length < min ? `* Must be ${min} characters or more` : undefined
}

export const validateNull = (value) => {
    return !value || value.trim().length === 0 ? `* Must be atleast 1 character` : undefined
}

const maxLength = (max) => (value) => {
    return value && value.length > max ? `* Must be ${max} characters or less` : undefined
}

export const verifyAngle = (value) => {
    console.log(/^(?:[0-9]|[1-9][0-9]|[1-2][0-9]{2}|3[0-5][0-9])$/.test(value))
    return value && /^(?:[0-9]|[1-9][0-9]|[1-2][0-9]{2}|3[0-5][0-9])$/.test(value) ? undefined : 'Must be positive integer between 0-359'; 
}

export const max10 = maxInteger(10);
export const minLength6 = minLength(6);
export const minLength8 = minLength(8);
export const maxLength2 = maxLength(2);
export const maxLength20 = maxLength(20);
export const maxLength32 = maxLength(32);
export const maxLength60 = maxLength(60);
export const maxLength128 = maxLength(128);
export const maxLength256 = maxLength(256);
export const vapPasswdLength = maxminLength(8,63);
export const vapSsidLength = maxminLength(1,32);
export const passwordLength = maxminLength(5,32);

export const verifyPasswordConsistent = (value, values) => {
    let newPassword = values.inputNewPassword;    
    return newPassword === value ? undefined : '* No consistent with another one';
}

export const verifyWebUrl = (value, formObj, e, fieldName) => {
    return verifyUrl(value, '* The Web Url is not correct.');
}

export const verifyTelNumber = (value, refMsg) => {
    const msg = (refMsg && typeof refMsg === 'string') ? refMsg : '* Invalid telephone number';
    return value && !/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s0-9]*$/.test(value) ? msg : undefined;
}

export const verifyLongitude = (value, refMsg) => {
    const msg = refMsg ? refMsg : '* Invalid longitude';
    return value && !/^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,6})?))$/.test(value) ? msg : undefined;
}

export const verifyLatitude = (value, refMsg) => {
    const msg = refMsg ? refMsg : '* Invalid latitude';
    return value && !/^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,6})?))$/.test(value) ? msg : undefined;
}

export const verifyTimezone = (value, refMsg) => {
    const msg = refMsg ? refMsg : '* Invalid timezone';
    return value && !/[+-][0-9]{2}:[0-9]{2}\b/.test(value) ? msg : undefined;
}

export const verifyTimeFormat = (value, refMsg) => {
    const msg = refMsg ? refMsg : '* Invalid time format';
    return value && !/^(1[0-2]|0?[0-9]):([0-5]?[0-9]):([0-5]?[0-9])$/.test(value) ? msg : undefined;
}

export const verifyBlockValueBySelect = (value, allValues, props) => {
    if (!value) {
        return 'Required';
    } else {
        // if (index !== undefined && allValues.ruleSet && allValues.ruleSet[index].targetType === 'mac') {
        //     const msg = '*Target' + index + ' Invalid MAC Address';
        //     return !/^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/.test(value) ? msg : undefined;
        // }
        return value;
    }
    // alert(value);
    // if (value === 'mac') {
    //     const msg = '* Invalid MAC Address';
    //     return value && !/^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/.test(value) ? msg : undefined;
    // }
}

export const verifyIpv4 = (value, refMsg) => {
    const msg = 'Invalid IP Address';
    return value && !/^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)(\.(?!$)|$)){4}$/.test(value) ? msg : undefined;
}
export const verifyIpv6= (value, refMsg) => {
    const ipv6Pattern = /^(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$|^(?:[0-9a-fA-F]{1,4}:){6}(?::[0-9a-fA-F]{1,4})?$|^(?:[0-9a-fA-F]{1,4}:){5}(?::[0-9a-fA-F]{1,4}:){1,2}$|^(?:[0-9a-fA-F]{1,4}:){4}(?::[0-9a-fA-F]{1,4}:){1,3}$|^(?:[0-9a-fA-F]{1,4}:){3}(?::[0-9a-fA-F]{1,4}:){1,4}$|^(?:[0-9a-fA-F]{1,4}:){2}(?::[0-9a-fA-F]{1,4}:){1,5}$|^(?:[0-9a-fA-F]{1,4}:){1}(?::[0-9a-fA-F]{1,4}:){1,6}$|^::$/;
    const msg = 'Invalid IP Address';
    return value && !ipv6Pattern.test(value) ? msg : undefined;
}

export const verifyVlanId= (value, refMsg) => {
    const msg = "VLAN ID range from 2 to 4094";
    return value && (value <2 || value > 4094) ? msg : undefined;
}

export const isValidNetwork = ( ip, netmask ) => {
    var result = {'isValid': true};
    var pattern = /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)(\.(?!$)|$)){4}$/;
    var netmaskPattern = /^[\d]+$/;
    if (!pattern.test(ip)) {
      result = {'isValid': false, 'msg': 'Invalid IP address'};
      return result;
    }
    if(netmask < 16 || netmask > 28 || !netmaskPattern.test(netmask)){
      result = {'isValid': false, 'msg': 'Netmask must be between 16 and 28 inclusive.(ex:192.168.1.1/24)'};
      return result;
    }
    return result;
};

export const verifyIpv4Cidr = (value, refMsg) => {
    if (value) {
        let networkArray = value.split('/')
        let checkResult = isValidNetwork(networkArray[0], networkArray[1]);

        if (!checkResult.isValid) {
            return checkResult.msg;
        }
    }
}

export const verifyIpv4CidrForSubnet = (value, refMsg) => {
    if (value) {
        let networkArray = value.split('/')
        let checkResult = isValidNetwork(networkArray[0], networkArray[1]);

        if (checkResult.isValid) {
            return true;
        } else {
            return false;
        }
    }
}

export const verifySsidFormat = (value, refMsg) => {
    const msg = '* Invalid Input SSID';
    return value && !/^[^\\/!@#$%^&*;"'`[\]{}<>|?]([a-zA-Z\d\s]|[=+:,.()_-])*$/.test(value) ? msg : undefined;
}

export const verifyNetmask = (value, refMsg) => {
    const msg = 'Invalid Input Netmask';
    return value && !/^(((255\.){3}(255|254|252|248|240|224|192|128|0+))|((255\.){2}(255|254|252|248|240|224|192|128|0+)\.0)|((255\.)(255|254|252|248|240|224|192|128|0+)(\.0+){2})|((255|254|252|248|240|224|192|128|0+)(\.0+){3}))$/.test(value) ? msg : undefined;
}

export const verifyTimeArchive= (value, refMsg) => {
    const msg = "Time archive should be 1 to 10";
    return value && (value <1 || value > 10) ? msg : undefined;
}